import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { clearLayoutComponent } from 'app/layout/layouts/clear/clear.component';

@NgModule({
    declarations: [
        clearLayoutComponent
    ],
    imports     : [
        RouterModule,
        SharedModule
    ],
    exports     : [
        clearLayoutComponent
    ]
})
export class clearLayoutModule
{
}
